import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useInspecaoPatrimonioListaFilter
 */

type State = {
  status: number;
  dataDe?: Date | null;
  dataAte?: Date | null;
};

type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
};

export const initialFiltersValues: State = {
  status: 2,
  dataDe: null,
  dataAte: null,
};

export const useInspecaoPatrimonioListaFilter = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setFilters: (filters: Partial<State>) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set(() => ({ ...initialFiltersValues })),
}));